import React, { useCallback, useContext, useEffect } from 'react';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { focusEditor } from '../../../CommentEditor.editor_v3/redux/actionCreators';
import CommentBox from '../../../CommentBox/presets/CommentBox';
import { CommentContext } from '../../CommentContext';
/** A comment edit view we use for most comment presets. As of writing, this is just our CommentBox with some filled in fields. */ const EditView = ({ className, canPostComment, onCommentUpdated })=>{
    const dispatchFocusEditor = useAction(focusEditor);
    const isEditorCommentFlagEnabled = useFlag('editor_comment');
    const { comment, setEditingState } = useContext(CommentContext);
    const onCloseEditor = useCallback(()=>{
        setEditingState('none');
    }, [
        setEditingState
    ]);
    const onEditDone = useCallback((result)=>{
        setEditingState('none');
        onCommentUpdated && result.comment && onCommentUpdated(result);
    }, [
        setEditingState,
        onCommentUpdated
    ]);
    const editorId = `edit-${comment.commentId}`;
    useEffect(()=>{
        if (isEditorCommentFlagEnabled) {
            dispatchFocusEditor(editorId);
        }
    }, [
        isEditorCommentFlagEnabled,
        dispatchFocusEditor,
        editorId
    ]);
    return /*#__PURE__*/ React.createElement(CommentBox, {
        className: className,
        onPublishSuccess: onEditDone,
        id: editorId,
        commentableType: comment.typeId,
        commentableItemId: comment.itemId,
        editComment: comment,
        // FEATURE CLEANUP: editor_comment remove autoFocus prop
        autoFocus: true,
        onClose: onCloseEditor,
        canPostComment: canPostComment
    });
};
EditView.displayName = 'EditView';
export default EditView;

//# sourceMappingURL=EditView.js.map